// The Settings modal is opened by route, so "close" needs to know which page the
// user was on before they opened it. A tracker records every page outside
// /settings (with its position in the browser history), and the modal's close
// button returns there.
const KEY = "settings:return";

export const rememberSettingsReturn = (pathname, search = "", index = null) => {
  if (!pathname || pathname.startsWith("/settings")) return;
  try {
    window.sessionStorage.setItem(
      KEY,
      JSON.stringify({ path: `${pathname}${search}`, index })
    );
  } catch (error) {
    // Storage can be blocked; closing then falls back to the dashboard.
  }
};

export const getSettingsReturn = () => {
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(KEY));
    return stored?.path ? stored : null;
  } catch (error) {
    return null;
  }
};
